export default __webpack_public_path__ + "static/media/mountains_banner.2a544e78.png";